// redux imports
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 
import thunk from 'redux-thunk';

// slices
import userReducer from './slices/user';


const middleWareEnhancer = applyMiddleware(thunk);

const rootReducer = combineReducers({
    user: userReducer,
})

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
    let store = createStore(persistedReducer, middleWareEnhancer);
    let persistor = persistStore(store);
    return {store, persistor};
};
